import { AppointmentStatus } from '@/services/appointment-service';


export const statusLabels: Record<AppointmentStatus, string> = {
  booked: 'Marcado',
  fit_in: 'Encaixe',
  canceled: 'Cancelado',
  unbooked: 'Desmarcado',
  no_show: 'Faltou',
  rescheduled: 'Remarcado',
  arrived: 'Na recepção',
  in_progress: 'Em Atendimento',
  attended: 'Atendido',
  not_attended: 'Não Atendido'
};

export const statusColors: Record<AppointmentStatus, string> = {
  booked: 'bg-muted/10 text-muted-foreground border-muted',
  fit_in: 'bg-muted/10 text-muted-foreground border-muted',
  canceled: 'bg-destructive/10 text-destructive border-destructive/20',
  unbooked: 'bg-orange-50 text-orange-600 border-orange-300',
  no_show: 'bg-destructive/20 text-destructive border-destructive/30',
  rescheduled: 'bg-destructive/10 text-destructive border-warning/20',
  arrived: 'bg-warning/10 text-warning border-warning/20',
  in_progress: 'bg-accent/10 text-accent border-accent/20',
  attended: 'bg-success/10 text-success border-success/20',
  not_attended: 'bg-destructive/20 text-destructive border-destructive/30'
};
//'bg-muted/10 text-muted-foreground border-muted',

export const ScheduleStatusColors: Record<AppointmentStatus, string> = {
  booked: 'bg-white text-green-700 border-green-700',
  fit_in: 'bg-yellow-100 text-yellow-700 border-yellow-300',
  confirmed: 'bg-success/10 text-green-700 border-green-700',
  canceled: 'bg-red-50 text-red-600 border-red-300',
  unbooked: 'bg-orange-50 text-orange-600 border-orange-400',
  no_show: 'bg-destructive/20 text-destructive border-destructive/30',
  rescheduled: 'bg-yellow-50 text-destructive border-destructive/20',
  arrived: 'bg-warning/10 text-warning border-warning/20',
  in_progress: 'bg-accent/10 text-accent border-accent/20',
  attended: 'bg-blue-100 text-blue-700 border-destructive/30',
  not_attended: 'bg-destructive/20 text-destructive border-destructive/20'
};

